import { useState } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(true); // siempre visible al cargar la página

  // Opcional: si querés que al navegar dentro de la SPA (sin recargar) no vuelva a aparecer,
  // no hagas nada más. Si querés que reaparezca en cada ruta, sería otra lógica.

  const handleAccept = () => {
    setVisible(false); // lo oculta SOLO en esta visita (hasta el próximo reload)
    // Si cargás Heap u otros scripts solo tras aceptar, podés disparar un evento:
    // window.dispatchEvent(new CustomEvent("cookiesAccepted"));
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 bg-gray-100 border-t border-gray-300 text-center py-2 px-3 text-xs text-gray-700">
      <span>
        Al navegar por este sitio <strong>aceptás el uso de cookies</strong> para
        agilizar tu experiencia de compra.{" "}
      </span>
      <button onClick={handleAccept} className="underline text-xs text-gray-800">
        Entendido
      </button>
    </div>
  );
}